import * as React from "react";
import { SVGProps, memo } from "react";

const IconMultiChoice = (props: SVGProps<SVGSVGElement> & { slot?: string }) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11 4H21V6H11V4ZM11 8H17V10H11V8ZM11 14H21V16H11V14ZM11 18H17V20H11V18ZM3 14H9V20H3V14ZM5 16V18H7V16H5Z" fill="currentColor" /><path d="M5.207 7.293L3.914 6L2.5 7.414L5.207 10.121L9.914 5.414L8.5 4L5.207 7.293Z" fill="currentColor" /></svg>;

const Memo = memo(IconMultiChoice);
export default Memo;